import React, { Fragment } from 'react'
import { GoogleMap, Marker } from '@react-google-maps/api'

import mapStyles from '@ecm/config/Map'
import { Address } from '@ecm/data/Address'
import { Location } from '@ecm/data/Location'

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const google: any

type MapProps = {
  center?: Location | google.maps.LatLng | undefined
  markers?: Address[]
  onBoundsChanged?: () => void
  onClickMarker: (a: Address) => () => void
  onDblClickMarker: (a: Address) => () => void
  onDragEnd?: () => void
  onLoad: (map: google.maps.Map) => void
  onZoomChanged?: () => void
  selectedAddresses?: Address[]
  zoom?: number
}

const Map = ({
  center,
  markers = [],
  onBoundsChanged,
  onClickMarker,
  onDblClickMarker,
  onDragEnd,
  onLoad,
  onZoomChanged,
  selectedAddresses = [],
  zoom = 12,
}: MapProps) => {
  const containerStyle = {
    height: '100%',
    width: '100%',
  }

  const mapOptions = () => ({
    mapTypeControl: false,
    streetViewControl: false,
    styles: mapStyles,
    zoomControlOptions: { position: google.maps.ControlPosition.LEFT_TOP },
  })

  return (
    <GoogleMap
      center={center || markers[0].location}
      mapContainerStyle={containerStyle}
      onBoundsChanged={onBoundsChanged}
      onDragEnd={onDragEnd}
      onLoad={onLoad}
      onZoomChanged={onZoomChanged}
      options={mapOptions()}
      zoom={zoom}
    >
      {markers.map((a, idx) => {
        const isSelected = selectedAddresses.map(a => a.slug).includes(a.slug)
        const icon = {
          scaledSize: new google.maps.Size(35, 35),
          url: `/images/icon/${isSelected ? 'location-pin-lucky' : 'location-pin-primary'}.svg`,
        }
        return (
          <Fragment key={idx}>
            <Marker
              key={idx}
              position={a.location}
              icon={icon}
              title={`${a.street1}, ${a.city}, ${a.stateAbbreviation}`}
              onClick={onClickMarker(a)}
              onDblClick={onDblClickMarker(a)}
              zIndex={isSelected ? 10 : 9}
            />
          </Fragment>
        )
      })}
    </GoogleMap>
  )
}

export default Map
